export default __webpack_public_path__ + "static/media/fewClouds.d0e3af4e.jpg";